import { render, staticRenderFns } from "./SurveyCreator.vue?vue&type=template&id=b84774fa&scoped=true&"
import script from "./SurveyCreator.vue?vue&type=script&lang=js&"
export * from "./SurveyCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84774fa",
  null
  
)

export default component.exports